import { Colors } from '../../consts/Colors';
import { tags } from '../../consts/Tags';

export default class Zone1 extends Phaser.GameObjects.Container {
    constructor(scene, zoneData) {
        super(scene, zoneData.zoneX, 578, []);

        scene.add.existing(this);
        this.scene = scene;
        this.index = zoneData.index;
        this.zoneId = zoneData.zoneId;
        this.areaColor = zoneData.areaColor;
        this.areaHeight = 80;
        this.otherZone
        this.isError = false;
        this.upLevel = 0


        this.dropZone = this.scene.add.image(0, 0, 'dropzone1').setOrigin(0.5);
        this.add(this.dropZone);

        this.coloredArea = this.scene.add.rectangle(0, this.dropZone.height / 2, this.dropZone.width, this.areaHeight, this.areaColor).setOrigin(0.5, 1);
        this.add(this.coloredArea);

        this.areaText = this.scene.add.rexTagText(0, this.dropZone.height / 2 - this.coloredArea.height / 2, zoneData.areaContent, {
            color: Colors.Text.White,
            tags: tags,
            fontSize: '38px',
            lineSpacing: -10,
            fontFamily: 'MassiliaMedium',
            backgroundColor: 'transparent',
            align: 'center',
        }).setOrigin(0.5);
        this.add(this.areaText);

    }

    setActive() {
        this.isError = false;
        this.dropZone.setTint(0xFFFFFF);
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
    }

    addDeck(deck) {
        this.deck = deck;
    }

    changeRect() {
        let tweenHeight
        if (this.zoneId === 1) {
            this.areaHeight = 80 + 114 * this.upLevel;
            tweenHeight = 114;
        } else {
            this.areaHeight = 80 + 228 * (this.upLevel);
            tweenHeight = 228;
        }
        let cornerRadius = 0;
        if (this.upLevel == 5) {
            cornerRadius = 30;
        }
        let rect1 = this.scene.add.rexRoundRectangle(0, this.height / 2 - this.areaHeight, this.dropZone.width, 0, {
            tl: cornerRadius,
            tr: cornerRadius,
            bl: 0,
            br: 0
        }, this.areaColor).setOrigin(0.5, 1).setDepth(0)
        this.add(rect1);
        this.scene.tweens.add({
            targets: rect1,
            height: tweenHeight,
            duration: 500,
            onUpdate: () => {
                rect1.y = this.height / 2 - this.areaHeight;
            },
            onComplete: () => {
                if (this.deck.num === 8) {
                    this.scene.endGame()
                }
                // if (this.index === 1 && this.upLevel === 5) {
                //     this.addDotLine()
                // } else if (this.index === 2 && this.upLevel === 6) {
                //     this.addDotLine()
                // }
            }
        })
        this.upLevel++
    }



    setGood() {

    }

    setWrong(cardImg) {
        this.isError = true;

        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.item.setTexture(cardImg);
        this.itemStroke = this.scene.add.graphics();
        this.itemStroke.lineStyle(5, Colors.Elmt.Red, 1); // Définit l'épaisseur et la couleur de la bordure
        this.itemStroke.strokeRect(
            -this.item.displayWidth / 2,
            -this.item.displayHeight / 2,
            this.item.displayWidth,
            this.item.displayHeight
        );
        this.add(this.itemStroke);
        // this.itemStroke.setScale(0.9)
        this.itemStroke.setAlpha(0);
        this.scene.tweens.add({
            targets: this.itemStroke,
            alpha: 1,
            duration: 250,
            // ease: 'Linear',
            repeat: 2,
            yoyo: true,
            onComplete: () => {
                // this.item.setScale(0.5);
            }
        });
        this.disableInteractive();
    }

    onPointerOver() {
        this.dropZone.setTint(0x777777);
    }
    onPointerOut() {
        this.dropZone.setTint(0xFFFFFF);
    }
    dragOnPointerOver() {
        this.dropZone.setTint(0x777777);
    }
    dragOnPointerOut() {
        this.dropZone.setTint(0xFFFFFF);
    }

    addDotLine() {
        if (this.index === 1) {
            this.dotLine = this.scene.add.image(-this.dropZone.width / 2 - 18, -152, 'dotLine').setOrigin(0, 0);
        } else if (this.index === 2) {
            this.dotLine = this.scene.add.image(this.dropZone.width / 2 + 18, -384, 'dotLine').setOrigin(1, 0);
        }
        this.add(this.dotLine);
    }

}